import { useAuth } from '../../context/AuthContext';
import { ChevronDownIcon, Bars3Icon } from '@heroicons/react/24/outline';
import NotificationBell from '../NotificationBell';
import { deriveNameFromEmail } from '../../utils/nameFromEmail';

const headerStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600&display=swap');
  .sh-header { height:60px; min-height:60px; background:#ffffff; border-bottom:1px solid #eaecf4; display:flex; align-items:center; justify-content:space-between; padding:0 24px; font-family:'Sora',sans-serif; flex-shrink:0; }
  .sh-left { display:flex; align-items:center; gap:8px; }
  .sh-breadcrumb { font-size:.8rem; color:#b0b5cc; }
  .sh-sep  { color:#d8dce8; font-size:.8rem; }
  .sh-page { font-size:.82rem; color:#1a1d2e; font-weight:600; }
  .sh-right { display:flex; align-items:center; gap:8px; }
  .sh-icon-btn { width:36px; height:36px; border-radius:10px; border:1px solid #eaecf4; background:#f8f9fc; display:flex; align-items:center; justify-content:center; cursor:pointer; position:relative; transition:background .15s; }
  .sh-icon-btn:hover { background:#f0f2f8; }
  .sh-icon-btn svg { width:17px; height:17px; stroke:#6b7194; stroke-width:1.7; }
  .sh-divider { width:1px; height:24px; background:#eaecf4; margin:0 4px; }
  .sh-user { display:flex; align-items:center; gap:10px; padding:5px 10px 5px 5px; border-radius:12px; cursor:pointer; transition:background .15s; border:1px solid transparent; }
  .sh-user:hover { background:#f5f6fb; border-color:#eaecf4; }
  .sh-avatar { width:32px; height:32px; border-radius:10px; background:linear-gradient(135deg,#8b5cf6,#6366f1); display:flex; align-items:center; justify-content:center; font-size:.75rem; font-weight:700; color:white; flex-shrink:0; }
  .sh-name { font-size:.8rem; font-weight:600; color:#1a1d2e; }
  .sh-role { font-size:.68rem; color:#9094a8; margin-top:2px; }
  .sh-user svg { width:14px; height:14px; stroke:#b0b5cc; stroke-width:2; margin-left:2px; }
  .sh-logout { padding:7px 14px; background:#fff1f1; color:#ef4444; border:1px solid #fecaca; border-radius:9px; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; transition:background .15s; }
  .sh-logout:hover { background:#fee2e2; }
  .sh-hamburger { display:none; }
  @media (max-width:768px) {
    .sh-header { padding:0 16px; }
    .sh-hamburger { display:flex; }
    .sh-breadcrumb, .sh-sep { display:none; }
    .sh-name, .sh-role, .sh-user svg { display:none; }
    .sh-user { padding:4px; }
    .sh-divider { display:none; }
    .sh-logout { padding:6px 10px; font-size:.72rem; }
  }
`;

const getInitials = (name='') => name.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2) || 'S';

export const StudentHeader = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const displayName = user?.name || deriveNameFromEmail(user?.email) || 'Student';
  return (
    <>
      <style>{headerStyle}</style>
      <header className="sh-header">
        <div className="sh-left">
          <button className="sh-icon-btn sh-hamburger" onClick={onMenuClick} style={{border:'none',background:'transparent'}}>
            <Bars3Icon />
          </button>
          <span className="sh-breadcrumb">School Portal</span>
          <span className="sh-sep">/</span>
          <span className="sh-page">Student</span>
        </div>
        <div className="sh-right">

          {/* ── Notification Bell ── */}
          <NotificationBell />

          <div className="sh-divider" />
          <div className="sh-user">
            <div className="sh-avatar">{getInitials(displayName)}</div>
            <div>
              <div className="sh-name">{displayName}</div>
              <div className="sh-role">Student</div>
            </div>
            <ChevronDownIcon />
          </div>
          <div className="sh-divider" />
          <button className="sh-logout" onClick={logout}>Logout</button>
        </div>
      </header>
    </>
  );
};

export default StudentHeader;